import { useTranslation } from 'react-i18next';

import { SewBillingCycleRangeExport } from '@/backoffice/features/data-exports/sew-billing-cycle-range-export/sew-billing-cycle-range-export';
import { useLazySewSalesExportQuery } from '@/backoffice/redux/api/billing-backoffice/billing-backoffice-api';
import { SalesIcon } from '@/shared/assets/icons/sales-icon';

export const SewSalesExport = () => {
  const { t } = useTranslation();
  const [getFile] = useLazySewSalesExportQuery();

  const fetchExport = async (
    startBillingCycleReferenceTs: number,
    endBillingCycleReferenceTs: number,
  ) => {
    const response = await getFile({
      startBillingCycleReferenceTs,
      endBillingCycleReferenceTs,
    }).unwrap();
    return response?.sewSalesExport;
  };

  return (
    <SewBillingCycleRangeExport
      icon={<SalesIcon />}
      title={t('backoffice:sew.data_exports.sales.title')}
      description={t('backoffice:sew.data_exports.sales.description')}
      loaderText={t('backoffice:sew.data_exports.sales.loader_text')}
      baseFileNamePrefix="sew_sales_export"
      fetchExport={fetchExport}
    />
  );
};
